import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { cleanObjectEmptyFields, createQueryKey } from '@hero/utils';

import { services } from '../../services';

export const useGetGraphData = (params = {}, options = {}) => {
  const {
    type = '',
    associationType = '',
    associationCode = '',
    startDate = '',
    endDate = ''
  } = params;

  return useQuery(
    createQueryKey(QUERY_KEYS.useGetGraphDataKey, params),
    () =>
      services.getGraphData(
        cleanObjectEmptyFields({
          type,
          associationType,
          associationCode,
          startDate,
          endDate
        })
      ),
    {
      enabled: !!associationCode,
      ...options
    }
  );
};
